import { PrivilegeEnum as e } from "@hprofits/shared/auth";
import { HttpStatus as d } from "@hprofits/utils";
import { ocPrivate as r } from "../common/auth/procedure-builders.js";
import "../common/errors/constants.js";
import { notFoundError as s, requestValidationError as u, inUseError as g } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as a } from "../swagger/tags.js";
import { UserIdParamSchema as o, UserAdExchangeBindingSchema as m, BindUserAdExchangeSchema as h, AdExchangeOwnerConflictDataSchema as i, UpdateUserGrantsSchema as p, UserCardSchema as n, UpdateUserRolesSchema as S, BanUserSchema as U, AssignUserManagerSchema as E, UpdateUserProfileSchema as c, UsersQuerySchema as f, UsersResponseSchema as T } from "./schemas.js";
const t = "User not found", R = "AD_EXCHANGE_OWNER_CONFLICT", O = {
  user: {
    findAll: r([e.ManageUsers]).route({
      method: "GET",
      path: "/users",
      summary: "List users",
      tags: [a.USERS.name]
    }).input(f).output(T).errors({}),
    findOne: r([e.ManageUsers]).route({
      method: "GET",
      path: "/users/{userId}",
      summary: "Get a user card",
      tags: [a.USERS.name]
    }).input(o).output(n).errors({
      ...s(t)
    }),
    updateProfile: r([e.ManageUsers]).route({
      method: "PATCH",
      path: "/users/{userId}",
      summary: "Update the profile of a user",
      tags: [a.USERS.name]
    }).input(c).output(n).errors({
      ...s(t),
      ...u("The profile data was refused")
    }),
    assignManager: r([e.ManageUsers]).route({
      method: "PUT",
      path: "/users/{userId}/manager",
      summary: "Assign a manager to a user",
      tags: [a.USERS.name]
    }).input(E).output(n).errors({
      ...s(t),
      ...u("The manager was refused")
    }),
    unassignManager: r([e.ManageUsers]).route({
      method: "DELETE",
      path: "/users/{userId}/manager",
      summary: "Remove the manager of a user",
      tags: [a.USERS.name]
    }).input(o).output(n).errors({
      ...s(t)
    }),
    ban: r([e.ManageUsers]).route({
      method: "POST",
      path: "/users/{userId}/ban",
      summary: "Ban a user",
      tags: [a.USERS.name]
    }).input(U).output(n).errors({
      ...s(t),
      ...u("The ban was refused")
    }),
    unban: r([e.ManageUsers]).route({
      method: "POST",
      path: "/users/{userId}/unban",
      summary: "Unban a user",
      tags: [a.USERS.name]
    }).input(o).output(n).errors({
      ...s(t),
      ...u("The unban was refused")
    }),
    updateRoles: r([e.ManageUsers]).route({
      method: "PUT",
      path: "/users/{userId}/roles",
      summary: "Replace the roles of a user",
      tags: [a.USERS.name]
    }).input(S).output(n).errors({
      ...s(t),
      ...u("The roles were refused"),
      ...g("The user is bound to an ad exchange; unbind it before removing the ad exchange role")
    }),
    updateGrants: r([e.ManageUsers]).route({
      method: "PUT",
      path: "/users/{userId}/grants",
      summary: "Replace the grants of a user",
      tags: [a.USERS.name]
    }).input(p).output(n).errors({
      ...s(t),
      ...u("The grants were refused")
    }),
    getAdExchange: r([e.ManageAdExchangeBindings]).route({
      method: "GET",
      path: "/users/{userId}/ad-exchange",
      summary: "Get the SSP/DSP binding of a user",
      tags: [a.USERS.name]
    }).input(o).output(m).errors({
      ...s(t)
    }),
    bindAdExchange: r([e.ManageAdExchangeBindings]).route({
      method: "PUT",
      path: "/users/{userId}/ad-exchange",
      summary: "Bind a user to an SSP and/or a DSP",
      tags: [a.USERS.name]
    }).input(h).output(m).errors({
      ...s(t),
      ...u("The binding was refused"),
      [R]: {
        status: d.CONFLICT,
        message: "The SSP/DSP is bound to another user; send replace to take it over",
        data: i
      }
    }),
    unbindAdExchange: r([e.ManageAdExchangeBindings]).route({
      method: "DELETE",
      path: "/users/{userId}/ad-exchange",
      summary: "Remove the SSP/DSP binding of a user",
      tags: [a.USERS.name]
    }).input(o).output(m).errors({
      ...s(t)
    })
  }
};
export {
  R as AD_EXCHANGE_OWNER_CONFLICT,
  O as userContract
};
//# sourceMappingURL=contract.js.map
